import track11 from '../../../../assets/audio/tracks/track11.mp3';

export const step11statue = {
    id: 11,
    title: '4. stanoviště',
    taskText: `
        <p>
            Tak socha prej říká, ať pokračujeme naproti přes silnici do parku. Že tam budou určitě vědět. On prý taky zaslechl, že je důležité to najít co nejdřív, jinak bude zle. 
        </p>
        <p>    
            A že nechápe, kdo to mohl ukrást. Tak vyrážíme za dalšími sochami. Až dojdete do parku tak klikněte na tlačítko níže.
        </p>
    `,
    catImage: 7,
    audio: track11,
    snowAudio: track11,
    continueButtonText: 'Dále',
};
